module.exports = __webpack_public_path__ + "static/media/luggages3.af6b22dd.jpg";